import React from "react";

const ChevronDown = () => (
  <svg width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.10645 1.1084L4.55469 4.66016L1.00293 1.1084" stroke="#21211D"/>
</svg>
);

export default ChevronDown;
